import { render, staticRenderFns } from "./FarmAddDialog.vue?vue&type=template&id=060a97bc&scoped=true"
import script from "./FarmAddDialog.vue?vue&type=script&lang=js"
export * from "./FarmAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a97bc",
  null
  
)

export default component.exports